<template>
  <div class="wt2-masthead-like-header" :class="type">
    <div class="-title">
      <div v-if="storyboard" class="wt2-story-template-tag">
        {{ 'generic.storyboard' | culture }}
      </div>
      <span class="wt2-text-l2">{{ title }}</span>
    </div>
    <div class="-actions">
      <div
        class="-icon-box wt2-pointer"
        @click="$emit('toggle')"
        :class="{ '-active': infoActive }"
      >
        <i class="wticon wticon-information1"></i>
      </div>
      <div
        class="-close-box"
        @click="
          analytics({ action: 'close', params: { Using: 'X' } });
          $emit('close');
        "
      >
        <wt-close></wt-close>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: 'transparent',
    },

    title: {
      type: String,
    },

    infoActive: {
      type: Boolean,
      default: false,
    },

    storyboard: {
      type: Boolean,
      default: false,
    },
    analytics: {
      type: Function,
      default: _.noop,
    },
  },
};
</script>

<style lang="scss"></style>
